import React, { useEffect, useRef, useState, useCallback } from "react";
// import ModalLogo from '../../../assets/images/modal_logo.png';
import closeIcon from "../../../assets/kudzu-plus-images/Close.png";
import "animate.css";
import { useSelector } from "react-redux";
import { appTheme, retrieveData } from "../../../helpers/utils/Utils";
import { convertTimestamp, clearStorageExceptKey, modifyHtmlForNavigation, useNotificationNavigation } from '../../../utils';
import { STATUS_SUCCESS_CODE } from '../../../network/URLConstants';
import Bell from "../../../assets/images/Bell.png"
import {NOTIFICATION_READ_ALERTS} from "../../../network/URLConstants";
import logFirebaseEvents from "../../LogFirebaseEvents";
import {formatDateAndTime} from '../../../utils/index';
import rightArrow from '../../../assets/images/right_dropdown_arrow.png';
import blueArrow from '../../../assets/images/right-arrow-enable.png';
import {
    GetApiHeadersWithBearer,
    GetRequest,
    PostRequest,
  } from "../../../network/NetworkUtils";
import { useNavigate } from "react-router";
import { useTranslation } from 'react-i18next';

const NotificationModal = (props) => {
  const { t } = useTranslation();
  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const signUpkudzuPlusTrue = useSelector(
    (state) => state.isSignUpKudzuplusTrue
  );
  const appThemeData = appTheme(signUpkudzuPlusTrue);
  const notificationNavigation = useNotificationNavigation();
  const navigate = useNavigate();

  const {
    notify,
    isOpen,
    onClose,
    title,
    content,
    subtitle,
    isLogo,
    isKudzuPlusBg,
    isClimbg,
    isIframe,
    defaultCornerRadius = true,
    isFooter = false,
    button1,
    button2,
  } = props;

  const modalRef = useRef(null);
  const [isclosed, setIsclosed] = useState(0);
  const [loaded, setLoaded] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [checkedSlides, setCheckedSlides] = useState({});

  const isiPhoneOriPad = () => /(iphone|ipad)/i.test(navigator.userAgent);
  const cards = useSelector(state => JSON.parse(state.userCards));
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const [promoKey, setPromoKey] = useState(loggedResponse?.Promos?.[0]?.PromoKey);
  const [isLoading, setIsLoading] = useState(false);
 
  const accessToken = useSelector(state => state.accessToken);
  const [alertIds, setAlertIds] = useState("")


  const applyDynamicStyles = () => {
    if (!modalRef.current) return;
    const headingElements = modalRef.current.querySelectorAll(".notification-title");


    if (headingElements.length > 0) {
      headingElements.forEach((el) => {
        el.style.fontSize = "24px";
        el.style.marginBottom = "16px";
        el.style.lineHeight = "1.4";
      });
    }


    const footeContentElemenets = modalRef.current.querySelectorAll(".notification-footnote");
    if (footeContentElemenets.length > 0) {
      footeContentElemenets.forEach((el) => {
        el.style.fontSize = "12px";
        el.style.lineHeight = "1.5";
      });
    }


    const nts_Link = modalRef.current.querySelectorAll(".notification-link");
    if (nts_Link.length > 0) {
      nts_Link.forEach((el) => {
        el.style.textDecoration = "underline";
      });
    }

    const nts_Text = modalRef.current.querySelectorAll(".notification-text");
    if (nts_Text.length > 0) {
      nts_Text.forEach((el) => {
        el.style.marginBottom = "40px";
      });
    }

    const notificationButtons = modalRef.current.querySelectorAll(".notification-button");
    if (notificationButtons.length > 0) {
      notificationButtons.forEach((btn) => {
        btn.style.backgroundColor = "#2a52be";
        btn.style.color = "#ffffff";
        btn.style.border = "none";
        btn.style.padding = "10px 16px";
        btn.style.borderRadius = "4px";
        btn.style.cursor = "pointer";
        //  btn.style.marginLeft = "200px";
        btn.parentElement.style.display = "flex";
        btn.parentElement.style.justifyContent = "center";
      });
    }

  };


  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (event.target.classList.contains("modal")) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("click", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    // if(isOpen && modalRef && modalRef.current)
    applyDynamicStyles();
}, [notify, currentSlide]);

  useEffect(() => {
    if (isOpen && modalRef.current) {
      // modalRef.current.classList.add('animate__animated', 'animate__fadeInUpBig');
      setIsclosed(2);
      setTimeout(() => {
        setLoaded(1);
      }, 500);
    } else if (modalRef.current) {
      setIsclosed(3);
      modalRef.current.classList.remove("fade-in");
    }
  }, [isOpen]);

  useEffect(() => {
   
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  if (!isOpen) {
    return null;
  }

  const handleClose = () => {
    const tooltipCookieNameForSaving = `NotificationModalfor_kudzu_badge-${cards[0].CardKey}`;
    // modalRef.current.classList.remove('animate__fadeInUpBig');
    // modalRef.current.classList.add('animate__fadeOutDown');
    // if(currentSlide >= notify.length) {
        sessionStorage.setItem(tooltipCookieNameForSaving, 'true', { expires: 1825 }, 2);
    // } else {
        // sessionStorage.removeItem(tooltipCookieNameForSaving);
    // }
     NotificationReadCall(notify[currentSlide - 1].ID);
    setIsclosed(1);
    setTimeout(() => {
      onClose();
    }, 500); // Adjust the timeout duration as needed
  };

  // const modalContainerClasses = `modal-container ${props?.bgColor ? props?.bgColor : isClimbg ? 'bg-climb-modal-bg opacity-50' :  'bg-card'}`;
  const modalContainerClasses = ` modal-container  ${
    props?.bgColor
      ? props?.bgColor
      : isClimbg
      ? "bg-climb-modal-bg"
      : isKudzuPlusBg
      ? "bg-[#262B3A]"
      : "bg-[var(--modalcard-bg)]"
  } ${
    defaultCornerRadius
      ? " sm:rounded-tl-card-tr sm:rounded-br-card-bl "
      : " sm:rounded-tr-[4rem] sm:rounded-bl-[4rem]"
  } md:w-[778px] sm:w-[466px] w-[100%] mx-auto shadow-lg z-50 h-[100vh] sm:h-fit sm:mb-10  ${
    loaded ? " overflow-y-auto " : ""
  } `;

  const nextSlide = () => {
    if (currentSlide < notify.length) {
      setCurrentSlide(currentSlide + 1);
    }

    const tooltipCookieNameForSaving = `NotificationModalfor_kudzu_badge-${cards[0].CardKey}`;

    if(currentSlide >= notify.length) {
        sessionStorage.setItem(tooltipCookieNameForSaving, 'true', { expires: 1825 }, 2);
    } else {
        sessionStorage.removeItem(tooltipCookieNameForSaving)
    }
  };

  const NotificationReadCall = async(alertIde) => {
    const AlertIdse = [alertIde];
    try {
        setIsLoading(true);

        const deviceId = await retrieveData('updatedDeviceId')
        const cardKey = cards !== null ? cards[0].CardKey : 0;

        const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
        const body = {
                        cardKey: cardKey,
                        AlertIds: AlertIdse,
                    };
        const url = NOTIFICATION_READ_ALERTS;
        const response = await PostRequest(url, body, headers);
        const responseJson = await JSON.parse(response);
        if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
            setIsLoading(false);
            console.log(responseJson);
        }

    } catch (error) {
        console.error("Error in :", error);
    }
  };

  return (
    <>
      {isOpen && (
        <div
          className="font-hanken-grotesk fixed top-0 left-0 w-full h-full flex justify-center items-center bg-[var(--kudzu-card-bg)] bg-opacity-90 overflow-y-auto "
          style={{ zIndex: 200 }}
        >
          <div
            className={`absolute sm:pt-[130px] bottom-0 left-1/2 w-full transform -translate-x-1/2 rounded-md ${
              loaded ? " overflow-y-auto " : "overflow-y-auto "
            }`}
            // className={`absolute sm:pt-[130px] bottom-0 left-1/2 w-full transform -translate-x-1/2 rounded-md ${loaded ? ' overflow-y-auto ' : ''}`}
            style={{
              position: "absolute",
              top: isclosed == 2 ? "0px" : "2000px",
              transition: "top 1s ease-in-out",
            }}
          ></div>
          <div 
            ref={modalRef} 
            className={modalContainerClasses}
            role="dialog"
            aria-modal="true"
            aria-labelledby="notification-title"
            aria-describedby="notification-content"
            aria-live="polite"
          >
            {/* className={modalContainerClasses} style={{ overflowY: 'auto' }} > */}
            <div className="modal-content text-left">
              <div
                className={`modal-body flex-col h-[100%] ${
                  isIframe
                    ? "flex justify-center"
                    : "flex justify-center items-center "
                } sm:my-[60px] md:mt-[110px] mt-[68px] mb-[20%] `}
              >
                <div
                  className={` ${
                    isIframe
                      ? " w-[85%] xsm:w-[100%]"
                      : "md:w-[430px] sm:w-[294px] xsm:w-[260px] w-[320px]"
                  } `}
                >
                  <div style={{ position: "relative" }} className={`ml[-27px] ${kudzuPlusTrue? "text-white": "text-black"}`}>
                    {" "}
                    {/* Add this line */}
                    {isLogo != undefined && isLogo && (
                      <img
                        src={appThemeData.ModalLogo}
                        className={` ${
                          signUpkudzuPlusTrue
                            ? ""
                            : "md:w-[130px] sm:w-[106px] w-[111px] sm:h-[32px] h-[33.43px] md:h-[39.15px]"
                        }  mb-[35px] md:mb-[51px]`}
                        alt="Modal Logo"
                      />
                    )}
                    <div id="notification-title" className="md:w-[430px] sm:w-[294px] xsm:w-[240px] w-[320px] ">
                      {title}
                      {subtitle}
                    </div>
                    {props?.subHeaderMsg && (
                      <div className="w-[320px] xsm:w-[260px] sm:w-[294px] md:w-[430px] mt-3 ml-[26px] sm:ml-[26px] md:ml-[-84px]">
                        {props.subHeaderMsg}
                      </div>
                    )}
                    {content}
                  </div>
                </div>
                <div
                  className={` ${
                    isIframe
                      ? " w-[85%] xsm:w-[100%]"
                      : "md:w-[700px] sm:w-[294px] xsm:w-[700px] w-[320px]"
                  }  sm:flex justify-center items-center p-6  flex flex-col`}
                >
                  <div className={`p-4  w-full rounded-md custom-content`}>
                    <div className="flex justify-between mb-[29px]">
                    <div>
                        <img src={Bell}  className="w-10 h-10 sm:w-6 sm:h-6 md:w-8 md:h-8 lg:w-8 lg:h-8 xl:w-20 xl:h-20 max-w-full" alt="Notification" />
                    </div>
                    <div>
                        <p className="text-[var(--notifiy-text-color)]">{formatDateAndTime(notify[currentSlide - 1].CreatedDateTime)}</p>
                    </div>
                    </div>
                    <div 
                      id="notification-content"
                      className="leading leading-6 text-[var(--notifiy-text-color)]" 
                      dangerouslySetInnerHTML={{ __html: notify[currentSlide - 1].Content }} 
                      onClick={(e) => {
                                            if (e.target.tagName === 'A') {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                const href = e.target.getAttribute('href');
                                                
                                                if (href && (href.startsWith('http://') || href.startsWith('https://'))) {
                                                    window.open(href, '_blank', 'noopener,noreferrer');
                                              } else if (href && href.includes('DDA')) {
                                                const tooltipCookieNameForSaving = `NotificationModalfor_kudzu_badge-${cards[0].CardKey}`;
                                                  sessionStorage.setItem(tooltipCookieNameForSaving, 'true', { expires: 1825 }, 2);
                                                     NotificationReadCall(notify[currentSlide - 1].ID);
                                                // If anchor tag contains DDA, redirect to ManageDirectDeposit
                                                navigate('/AccountServices/Spending/ManageDirectDeposit');
                                                } else {
                                                // For other cases, return empty (do nothing)
                                                                               return;
                                                                               }
                                                                           }
                                                                      }}></div>
                                                </div>

                                                <div className={`mt-8 flex w-full justify-between text-[var(--notifiy-text-color)] ml-[-26px]`} role="group" aria-label={t('notification_navigation')}>
                                                  <div>
                                                  <span className="mx-4" aria-live="polite" aria-atomic="true">
                                                    {t('notification_count', { current: currentSlide, total: notify.length }) || `${currentSlide}/${notify.length}`}
                                                  </span>
                    </div>
                    <div>
                    <button
                      type="button"
                      onClick={() => {
                        if (currentSlide < notify.length) {
                          NotificationReadCall(notify[currentSlide].ID);
                          nextSlide();
                        } else {
                          handleClose();
                        }
                      }}
                      aria-label={currentSlide >= notify.length ? t('closeNotification') : t('nextNotification')}
                    >
                      {currentSlide >= notify.length ? (
                        t('close')
                        ) : kudzuPlusTrue ? (
                        <div className="flex flex-row items-center gap-x-2">
                        <div>{t('next')}</div>
                          <div>
                        <img className="max-w-[56%]" src={blueArrow} alt={t('next')} />
                        </div>
                        </div>
                      ) : (
                        <div className="flex flex-row items-center gap-x-2">
                          <div>{t('next')}</div>
                          <div>
                            <img className="max-w-[40%]" src={rightArrow} alt={t('next')} />
                          </div>
                        </div>
                      )}
                      </button>
                    </div>
                  </div>

                  <button
                    type="button"
                    className={`absolute md:top-[-50px] sm:top-[-30px] modal-close text-gray-500 hover:text-gray-800 cursor-pointer ${
                      isIframe
                        ? "right-[9%] xsm:right-[9%] sm:right-[5%] md:right-[5%] lg:right-[5%] xl:right-[5%] top-[-68px]"
                        : "right-[2%] xsm:right-[-18%] sm:right-[-18%] md:right-[-24%] lg:right-[-27%] xl:right-[-25%] top-[-30px]"
                    }`}
                    onClick={handleClose}
                    aria-label={t('closeNotification') || 'Close notification'}
                  >
                      {kudzuPlusTrue ? (
                        <img src={closeIcon} alt="" className="opacity-50" aria-hidden="true" />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-[1rem] w-[1rem] opacity-[60%]"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          aria-hidden="true"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      )}
                    </button>

                </div>
              </div>
              {isFooter && (
                <div className="w-full  hidden sm:flex justify-center items-center p-6 bg-[#30BC89] ">
                  {button1}
                </div>
              )}
            </div>
          </div>
          {isOpen && isFooter && (
            <div className="w-full fixed bottom-0 left-0 sm:hidden justify-center items-center p-6 bg-[#30BC89] animate__animated animate__fadeInUpBig">
              {button1}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default NotificationModal;


// const applyDynamicStyles = () => {
//     const contentElement = document.querySelector(".custom-content");
  
//     // if (contentElement) {
//     //   // Apply styles to paragraphs
//     //   contentElement.querySelectorAll("p").forEach((el) => {
//     //     // el.style.color = "white";
//     //     el.style.fontSize = "16px";
//     //   });
  
//     //   // Apply styles to links
//     //   contentElement.querySelectorAll("a").forEach((el) => {
//     //     el.style.color = "#78b3f9";
//     //     el.style.cursor = "pointer";
//     //   });
//     // }
//   };
  
